"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Receptacle = void 0;
var AudioCategory = require("../Audio/AudioCategory");
var AudioToken_1 = require("../Audio/AudioToken");
var Topics = require("../Data/Topics");
var InputUtils = require("../Input/InputUtils");
var PixiUtils = require("../Utils/PixiUtils");
var RectUtils = require("../Utils/RectUtils");
/**
 * Receptacle
 */
var Receptacle = /** @class */ (function (_super) {
    __extends(Receptacle, _super);
    function Receptacle() {
        var _this = _super.call(this) || this;
        _this._isPointerOver = false;
        _this._isActive = true;
        _this._visuals = new PIXI.Container();
        _this.addChild(_this._visuals);
        _this.buttonMode = true;
        _this.interactive = false;
        _this.on(InputUtils.Events.POINTER_OVER, _this.onPointerOver);
        _this.on(InputUtils.Events.POINTER_DOWN, _this.onPointerDown);
        _this.on(InputUtils.Events.POINTER_UP, _this.onPointerUp);
        _this.on(InputUtils.Events.POINTER_UP_OUTSIDE, _this.onPointerUpOutside);
        _this.on(InputUtils.Events.POINTER_OUT, _this.onPointerOut);
        _this.on(InputUtils.Events.POINTER_MOVE, _this.onPointerMove);
        _this.on(InputUtils.Events.TOUCH_MOVE, _this.onTouchMove);
        _this._subscriptions = new Array();
        _this._subscriptions.push(PubSub.subscribe(Topics.DRAG_BEGIN, _this.onDragBegin.bind(_this)));
        _this._subscriptions.push(PubSub.subscribe(Topics.DRAG_END, _this.onDragEnd.bind(_this)));
        _this._subscriptions.push(PubSub.subscribe(Topics.DRAGGABLE_SELECTED, _this.onDraggableSelected.bind(_this)));
        _this._subscriptions.push(PubSub.subscribe(Topics.DRAGGABLE_DESELECTED, _this.onDraggableDeselected.bind(_this)));
        return _this;
    }
    Object.defineProperty(Receptacle.prototype, "isActive", {
        /**
         * Gets whether is active
         */
        get: function () {
            return this._isActive;
        },
        /**
         * Sets whether is active
         */
        set: function (pValue) {
            this._isActive = pValue;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * onFocusBegin
     */
    Receptacle.prototype.onFocusBegin = function () {
        this.playHoverVo();
    };
    /**
     * onFocusEnd
     */
    Receptacle.prototype.onFocusEnd = function () {
        // unused
    };
    /**
     * onFocusActivated
     */
    Receptacle.prototype.onFocusActivated = function () {
        this.addDraggable(this._selected);
    };
    /**
     * onFocusPosition
     */
    Receptacle.prototype.getFocusPosition = function () {
        if (this.hitArea instanceof PIXI.Rectangle) {
            return new PIXI.Point().copyFrom(this.toGlobal(RectUtils.center(this.hitArea)));
        }
        else {
            return this.getGlobalPosition();
        }
    };
    /**
     * Gets focus size
     * @returns PIXI.Point
     */
    Receptacle.prototype.getFocusSize = function () {
        var bounds;
        if (this.hitArea instanceof PIXI.Rectangle) {
            bounds = PixiUtils.getGlobalBounds(this, this.hitArea.clone());
        }
        else {
            bounds = PixiUtils.getGlobalBounds(this);
        }
        return RectUtils.size(bounds);
    };
    /**
     * Destroys receptacle
     */
    Receptacle.prototype.destroy = function () {
        for (var i = 0; i < this._subscriptions.length; ++i) {
            PubSub.unsubscribe(this._subscriptions[i]);
        }
        _super.prototype.destroy.call(this);
    };
    /**
     * Plays hover vo
     */
    Receptacle.prototype.playHoverVo = function () {
        if (this._hoverVo !== undefined) {
            PubSub.publishSync(Topics.PLAY_AUDIO, new AudioToken_1.AudioToken(this._hoverVo, 1, false, AudioCategory.VO.toString()));
        }
    };
    /**
     * onPointerOver
     */
    Receptacle.prototype.onPointerOver = function () {
        this._isPointerOver = true;
        if (this._selected !== undefined) {
            this.playHoverVo();
        }
    };
    /**
     * onPointerDown
     */
    Receptacle.prototype.onPointerDown = function (pEvent) {
        this._eventData = pEvent.data;
    };
    /**
     * onPointerUp
     */
    Receptacle.prototype.onPointerUp = function () {
        if (this._selected !== undefined) {
            this._eventData = undefined;
            this.addDraggable(this._selected);
        }
    };
    /**
     * onPointerUpOutside
     */
    Receptacle.prototype.onPointerUpOutside = function () {
        this._eventData = undefined;
    };
    /**
     * onPointerOut
     */
    Receptacle.prototype.onPointerOut = function () {
        this._isPointerOver = false;
    };
    /**
     * onPointerMove
     */
    Receptacle.prototype.onPointerMove = function (pEvent) {
        // override
    };
    Receptacle.prototype.onTouchMove = function (pEvent) {
        var local = pEvent.data.getLocalPosition(this);
        if (this._isPointerOver === false) {
            if (this.hitArea.contains(local.x, local.y)) {
                this.onPointerOver();
            }
        }
        else {
            if (this.hitArea.contains(local.x, local.y) === false) {
                this.onPointerOut();
            }
        }
    };
    /**
     * Adds draggable
     * @param pDraggable
     */
    Receptacle.prototype.addDraggable = function (pDraggable) {
        // override
    };
    /**
     * onDragBegin
     * @param pTopic
     * @param pDraggable
     */
    Receptacle.prototype.onDragBegin = function (pTopic, pDraggable) {
        if (this._isActive) {
            this.interactive = true;
            this._dragged = pDraggable;
        }
    };
    /**
     * onDragEnd
     * @param pTopic
     * @param pDraggable
     */
    Receptacle.prototype.onDragEnd = function (pTopic, pDraggable) {
        if (this._isActive) {
            if (this._isPointerOver && this._dragged !== undefined) {
                this.addDraggable(this._dragged);
            }
            this.interactive = false;
            this._dragged = undefined;
        }
    };
    /**
     * onDraggableSelected
     * @param pTopic
     * @param pDraggable
     */
    Receptacle.prototype.onDraggableSelected = function (pTopic, pDraggable) {
        if (this._isActive) {
            this.interactive = true;
            this._selected = pDraggable;
        }
    };
    /**
     * onDraggableDeselected
     * @param pTopic
     * @param pDraggable
     */
    Receptacle.prototype.onDraggableDeselected = function (pTopic, pDraggable) {
        if (this._isActive) {
            if (this._selected === pDraggable) {
                this.interactive = false;
                this._selected = undefined;
            }
        }
    };
    return Receptacle;
}(PIXI.Container));
exports.Receptacle = Receptacle;
//# sourceMappingURL=Receptacle.js.map